<div class="p-2 fw-bold">Incident Report</div>
<div class="row">
  <div class="col-12 col-md-6">
    @if (incidentDict.site.data?.id) {
      <div class="mb-2">
        <dl>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Site</dt>
              <dd (click)="editField('site')" class="link-edit">
                {{ incidentDict.site.value }}
                <div>[{{ incidentDict.client.value }}]</div>
              </dd>
            </div>
          </div>
        </dl>
      </div>
    }
    @if (!incidentDict.site.data?.id) {
      <div class="mb-3">
        <gtapp-auto-complete
          [data]="siteList"
          placeHolder="Site"
          searchKeyword="company_name"
          [initialValue]="incidentDict.site.tempValue"
          [itemTemplate]="siteTemplate"
          [addInitialKey]="isAdmin || isDispatchUser"
          (inputChanged)="onSiteSearch($event)"
          (selected)="onSelectSite($event)"
          inputId="siteId"
          [enableCloseOption]="true"
          (fieldCleared)="editField('site')"
        >
        </gtapp-auto-complete>
      </div>
    }

    <ng-template #siteTemplate let-item>
      @if (item?.key === 0) {
        <div>Create New Site</div>
      } @else {
        <div>
          <div class="fw-medium">
            {{ item?.company_name }} [{{ item?.company?.company_name }}]
          </div>

          <div class="small-font text-secondary">
            {{ item?.address?.full_address }}
          </div>
        </div>
      }
    </ng-template>

    @if (incidentDict.site.data?.id) {
      <dl>
        <dt>Incident Type</dt>
        <div class="d-flex flex-wrap gap-3 mb-2 p-2">
          @for (
            incidentType of selectedIncidentTypeList;
            track incidentType;
            let i = $index;
            let l = $last
          ) {
            <div>
              <div>
                <div>
                  @if (incidentType?.isFocused) {
                    <ng-container>
                      <div
                        class="mb-3"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Provide a short label for the incident (e.g. Broken Lock, Suspicious Person, Forced Entry)."
                        id="incidentTypeToolTipId"
                      >
                        <gtapp-auto-complete
                          [data]="incidentTypeList"
                          [maxLength]="256"
                          placeHolder="Incident Type"
                          searchKeyword="name"
                          [initialValue]="incidentDict.incidentType.tempValue"
                          [itemTemplate]="incidentTypeTemplate"
                          [addInitialKey]="incidentDict.incidentType.tempValue"
                          (inputChanged)="onSearchIncidentType($event)"
                          (selected)="onSelectIncidentType($event, i)"
                          inputId="iTypeLookupField"
                          [enableCloseOption]="true"
                          (fieldCleared)="editField('it')"
                          (blurTriggered)="checkAndAddIncidentType(i)"
                        >
                        </gtapp-auto-complete>
                      </div>
                      <ng-template #incidentTypeTemplate let-item>
                        @if (item?.key === 0) {
                          <div>Add Incident Type</div>
                        } @else {
                          <div>{{ item?.name }}</div>
                        }
                      </ng-template>
                    </ng-container>
                  } @else {
                    <ng-container>
                      <div class="d-flex flex-wrap mb-2 gap-2">
                        <div class="border rounded p-1 d-flex gap-2">
                          <div class="">
                            {{ incidentType?.name }}
                          </div>
                          <div (click)="deleteIncidentTypeField(i)">
                            <i class="fa-solid fa-minus-circle text-danger"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (selectedIncidentTypeList.length < 10) {
          <div class="text-end">
            <button
              (click)="addNewIncidentTypeField()"
              class="btn btn-primary"
              [disabled]="
                selectedIncidentTypeList?.length
                  ? !selectedIncidentTypeList[
                      selectedIncidentTypeList?.length - 1
                    ]?.name
                  : true
              "
            >
              Add Incident Type
            </button>
          </div>
        }
      </dl>
      <div class="col-md-12">
        <div class="form-floating mb-2">
          <input
            type="datetime-local"
            class="form-control"
            placeholder="Time of Incident"
            [(ngModel)]="incidentDict.iDay.value"
            (change)="formateStartDate($event)"
          />
          <label>Time of Incident</label>
        </div>
      </div>
      <div class="form-group input-group mb-2">
        <textarea
          class="form-control"
          placeholder="Description"
          rows="4"
          wrap="hard"
          maxlength="1500"
          type="text"
          [(ngModel)]="incidentDict.information.value"
          id="iiTextBox"
          (input)="onInput('iiTextBox')"
        ></textarea>
        @if (incidentDict?.information?.value) {
          <span
            class="input-group-text"
            (click)="
              incidentDict.information.value = '';
              clearAndFocusTextBox('iiTextBox')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    }
    <div class="row row-cols-2">
      <div class="col">
        <button class="btn btn-dark btn-lg w-100" [routerLink]="['/incidents']">
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            !(
              incidentDict.site.data?.id &&
              !addIncidentButtonPressed &&
              selectedIncidentTypeIdList?.length
            )
          "
          (click)="onAddIncident()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
  @if (
    incidentDict.site?.data?.address?.latitude &&
    incidentDict.site?.data?.address?.longitude
  ) {
    <div class="col-6 d-none d-md-block">
      <gtapp-map-leaflet
        [latLon]="{
          lat: incidentDict.site?.data?.address?.latitude,
          lon: incidentDict.site?.data?.address?.longitude,
        }"
        mapId="addIncidentMap"
      ></gtapp-map-leaflet>
    </div>
  }
</div>
